import React, {useRef, useState} from "react";
import useOnClickOutside from "use-onclickoutside";
import {Link} from "react-router-dom";
import {useSelector, useDispatch} from "react-redux";

import ResendSmsLink from "./MoreDrop/ResendSmsLink";
import WebPasSyncLink from "./MoreDrop/WebPasSyncLink";
import CloneToDemoLink from "./MoreDrop/CloneToDemoLink";
import CloneToTestLink from "./MoreDrop/CloneToTestLink";
import ToggleExternalCompletionLinks from "./MoreDrop/ToggleExternalCompletionLinks";
import CustomLogicItemMoreDrop from "../../CustomLogic/CustomLogicItemMoreDrop";
import LifehouseUploadPdfLink from "./MoreDrop/LifehouseUploadPdfLink";
import ArchiveAdmissionDocumentsLink from "./MoreDrop/ArchiveAdmissionDocumentsLink";
import CopyAdmissionData from "./MoreDrop/CopyAdmissionData";
import CopyPreAddDataLink from "./MoreDrop/CopyPreAddDataLink";
import ManagerCustomUI_MoreDrop from "./MoreDrop/ManagerCustomUI_MoreDrop";
import DeletePatientLink from "./MoreDrop/DeletePatientLink";
import Imp406Link from "./MoreDrop/Imp406Link";
import DemoMarkPaymentNotCompletedLink from "./MoreDrop/DemoMarkPaymentNotCompletedLink";
import {useCustomLogic} from "../../../utils/customLogic";
import {auroraPreviewRegXml} from "../../../store/actions/modal";
import {useToasts} from "react-toast-notifications";

const AdmissionList_Item_MoreDrop = ({admission}) => {
    const {manager_patientImpersonate_enable} = useSelector(state => state.auth);
    const state_showDevUI = useSelector(state => state.auth.state_showDevUI);
    const {isCustomLogicAurora} = useCustomLogic();
    const dispatch = useDispatch();
    const {addToast} = useToasts();

    const popupRef = useRef(null);
    const [popupOpen, setPopupOpen] = useState(false);
    const hidePopup = () => setPopupOpen(false);
    useOnClickOutside(popupRef, hidePopup);

    const togglePopup = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setPopupOpen(!popupOpen);
    }

    const renderImpersonateUI = () => (
            <>
                <div className="dropdown-divider" />
                <a className="dropdown-item pointer" href={`/admission/${admission.id}/impersonate`} target="_blank">View Patient Portal</a>
            </>
    );

    const renderDevUI = () => (
                <>
                    <div className="dropdown-divider" />
                    <CopyAdmissionData admission={admission} />
                    <Imp406Link admission={admission} onHide={hidePopup}/>
                    <div className="dropdown-divider" />
                    <CustomLogicItemMoreDrop admission={admission}/>
                    <CloneToDemoLink admission={admission}/>
                    <CloneToTestLink admission={admission}/>
                    <ToggleExternalCompletionLinks admission={admission}/>
                </>
            );

    return (
        <div className="more-options-drop d-flex" ref={popupRef}>
            <button type="button" className="dropdown-toggle dropdown-toggle-split" onClick={togglePopup}
                    id={`adm_dropdownMenuReference_${admission.id}`} data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false" data-reference="parent" >
                <span><i className="icon ico-more" /></span>
            </button>
            {popupOpen && <div className="dropdown-menu dropdown-menu-right show"
                 aria-labelledby={`adm_dropdownMenuReference_${admission.id}`}>
                <ManagerCustomUI_MoreDrop admission={admission} onHide={hidePopup}/>
                <Link to={`/admission/${admission.id}`} className="dropdown-item">View admission</Link>
                <ResendSmsLink admission={admission}/>
                <CopyPreAddDataLink admission={admission} onHide={hidePopup}/>
                <ArchiveAdmissionDocumentsLink admission={admission} onHide={hidePopup}/>
                <DeletePatientLink admission={admission}/>
                <WebPasSyncLink admission={admission} />
                <DemoMarkPaymentNotCompletedLink admission={admission} onHide={hidePopup}/>
                <LifehouseUploadPdfLink admission={admission} />
                {isCustomLogicAurora() && <_AuroraViewXml admission={admission} onHide={hidePopup} dispatch={dispatch} addToast={addToast}/> }
                {manager_patientImpersonate_enable && renderImpersonateUI()}
                {state_showDevUI && renderDevUI()}
            </div>}
        </div>
    );
}

const _AuroraViewXml = ({admission, onHide, dispatch, addToast}) => {
    const previewXml = () => {
        onHide();
        dispatch(auroraPreviewRegXml(admission, addToast));
    }

    return (
        <a className="dropdown-item pointer" onClick={previewXml}>[Aurora] - preview admission Reg XML</a>
    );
}

export default AdmissionList_Item_MoreDrop;